import React from 'react';
import { Icon } from 'b3';
import { connect } from 'react-redux';
import moment from 'moment';
import UserAvatar from '../../UserAvatar';
import ConfirmDeleteScheduleModal from '../../schedule/ConfirmDeleteModal';
import { openWizardToCompleteScheduledCall, openWizardToUpdateCall } from '../../schedule-wizard/logActivityReducer';
import ScheduleModal from '../../ScheduleModal';
import TimelineItem from './TimelineItem';
import UnCompletedActivityHeader from './UnCompletedActivityHeader';
import CompletedActivityHeader from './CompletedActivityHeader';
import NoteBubbleWithAvatar from './NoteBubbleWithAvatar';

@connect(
    (state, props) => ({
    	contacts: state.activeClient.contacts,
    }),
    { openWizardToCompleteScheduledCall, openWizardToUpdateCall }
)
export default class MeetingTimelineItem extends React.Component {
	confirmDelete(e){
	    e.preventDefault();
	    this.props.openModal(ConfirmDeleteScheduleModal, {scheduleId: this.props.id, type: this.props.type});
	}

	editMeeting() {
	    var meeting = this.props;

	    var props = {
	        ...meeting,
	        scheduleId: meeting.id,
	        clientId: meeting.clientId,
	        eventType: meeting.type,
	        hideEventTypes: true,
	        assignedUserIds: meeting.assignedUsers.map(u => u.id),
	        defaultAssignedUserIds: meeting.assignedUsers.map(u => u.id)
	    };

	    this.props.openModal(ScheduleModal, props);
	}
	openWizardToCompleteScheduledCall(fromAction) {
	    var { id, description, participatingContact, notes } = this.props;
	    var participatingContactId = participatingContact ? participatingContact.id : null;

	    var callData = {
	        id,
	        description,
	        notes,
	        date: moment(),
	        participatingContactId
	    };

	    this.props.openWizardToCompleteScheduledCall(callData, fromAction);
	}

	render() {
		var { assignedUsers, description, notes, completedAt, eventType, isNoShow, location, client } = this.props;

		var assignedUser = assignedUsers.length ? assignedUsers[0] : null; 

		var icon = <Icon icon="contacts-2" filled/>
		var avatar = <UserAvatar user={assignedUser} />

		var timelineType = isNoShow ? 'noshow' : eventType;
		var eventTypeCapitalised = eventType.capitalise();
		var typeLabel = isNoShow ? `No show ${eventTypeCapitalised}` : eventTypeCapitalised;

		if(completedAt) {
			return (
				<TimelineItem
					type={timelineType}
					typeLabel={typeLabel}
					icon={icon}
					openEditModal={this.editMeeting.bind(this)}
					openDeleteModal={this.confirmDelete.bind(this)}
					isCompleted={true}
					wrapInBubble={false}
				>
					<div>
						<CompletedActivityHeader
							client={client}
							scheduleName={eventType.capitalise()}
							avatar={avatar} 
							assignedUser={assignedUser} />
						<div className="scheduled-with-header"><strong>Agenda</strong></div>
						<p>{description}</p>
						<NoteBubbleWithAvatar 
							assignedUser={assignedUser}
							notes={notes} 
							avatar={avatar} />
					</div>
				</TimelineItem>
			);
		}

		var { tags, clientScore, numberOfStaff, date } =  this.props;

		return (
			<TimelineItem
				type={eventType}
				typeLabel={eventType.capitalise()}
				avatar={null}
				icon={icon}
				isEditable={true}
				isDeletable={true}
				openEditModal={this.editMeeting.bind(this)}
				openDeleteModal={this.confirmDelete.bind(this)}
				wrapInBubble={false}
			>
				<div>
					<UnCompletedActivityHeader
						date={date}
						location={location}
						isMeeting={true}
						score={clientScore}
						scheduleName="Meeting"
						tags={tags} 
						client={client}
						avatar={avatar} 
						numberOfStaff={numberOfStaff}
						assignedUser={assignedUser} />
					<div style={{display: 'flex'}}>
						<strong style={{marginRight: 15}}>Agenda</strong>
						<p style={{flex: 1}}>{description}</p>
					</div>
				</div>
			</TimelineItem>
		);
	}
}



// WEBPACK FOOTER //
// ./app/components/client-timeline/items/MeetingTimelineItem.js